import { clowncar } from 'types';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

import { toJSON } from '@tock/coretypes';

interface State {
  requestInProgress: boolean;
  preImportFileData?: clowncar.PreImportFileData;
  preImportReportInformation?: clowncar.PreImportReportInformation;
  postImportReportResponse?: clowncar.PostImportReportResponse;
}

const initialState: State = {
  requestInProgress: false,
  preImportFileData: undefined,
  preImportReportInformation: undefined,
  postImportReportResponse: undefined,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.IMPORT_REPORT_VALIDATE_FILE_STARTING:
    case ClowncarAppConstants.POST_IMPORT_REPORT_GENERATE_STARTING:
    case ClowncarAppConstants.PRE_IMPORT_REPORT_GENERATE_STARTING:
    case ClowncarAppConstants.IMPORT_WORKFLOW_CREATED_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case ClowncarAppConstants.IMPORT_REPORT_VALIDATE_FILE_FAILED:
    case ClowncarAppConstants.POST_IMPORT_REPORT_GENERATE_FAILED:
    case ClowncarAppConstants.PRE_IMPORT_REPORT_GENERATE_FAILED:
    case ClowncarAppConstants.IMPORT_WORKFLOW_CREATED_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case ClowncarAppConstants.IMPORT_REPORT_VALIDATE_FILE_DONE: {
      return {
        ...state,
        requestInProgress: false,
        preImportFileData: toJSON<clowncar.PreImportFileData>(payload),
      };
    }
    case ClowncarAppConstants.PRE_IMPORT_REPORT_GENERATE_DONE: {
      return {
        ...state,
        requestInProgress: false,
        preImportReportInformation: toJSON<clowncar.PreImportReportInformation>(payload),
      };
    }
    case ClowncarAppConstants.POST_IMPORT_REPORT_GENERATE_DONE: {
      return {
        ...state,
        requestInProgress: false,
        postImportReportResponse: toJSON<clowncar.PostImportReportResponse>(payload),
      };
    }
    default:
      return state;
  }
}
